import { EnemyState, EnemyType, POOL_CAPACITY } from '../constants';
import { IndexPool } from './IndexPool';

export class EnemyPool {
  readonly indices = new IndexPool(POOL_CAPACITY.enemies);
  readonly x = new Float32Array(POOL_CAPACITY.enemies);
  readonly y = new Float32Array(POOL_CAPACITY.enemies);
  readonly prevX = new Float32Array(POOL_CAPACITY.enemies);
  readonly prevY = new Float32Array(POOL_CAPACITY.enemies);
  readonly vx = new Float32Array(POOL_CAPACITY.enemies);
  readonly vy = new Float32Array(POOL_CAPACITY.enemies);
  readonly hp = new Float32Array(POOL_CAPACITY.enemies);
  readonly maxHp = new Float32Array(POOL_CAPACITY.enemies);
  readonly radius = new Float32Array(POOL_CAPACITY.enemies);
  readonly stateTimer = new Float32Array(POOL_CAPACITY.enemies);
  readonly attackTimer = new Float32Array(POOL_CAPACITY.enemies);
  readonly aux0 = new Float32Array(POOL_CAPACITY.enemies);
  readonly aux1 = new Float32Array(POOL_CAPACITY.enemies);
  readonly type = new Uint8Array(POOL_CAPACITY.enemies);
  readonly state = new Uint8Array(POOL_CAPACITY.enemies);
  readonly pattern = new Uint8Array(POOL_CAPACITY.enemies);
  readonly variant = new Uint8Array(POOL_CAPACITY.enemies);
  readonly flags = new Uint8Array(POOL_CAPACITY.enemies);
  readonly score = new Uint16Array(POOL_CAPACITY.enemies);
  readonly lux = new Uint8Array(POOL_CAPACITY.enemies);
  readonly lastAttackId = new Uint32Array(POOL_CAPACITY.enemies);
  overflowDrops = 0;

  spawn(type: EnemyType, x: number, y: number, hp: number, radius: number, pattern: number, variant: number, score: number, lux: number): number {
    const index = this.indices.acquire();
    if (index < 0) {
      this.overflowDrops += 1;
      return -1;
    }
    this.type[index] = type;
    this.state[index] = EnemyState.Spawn;
    this.pattern[index] = pattern;
    this.variant[index] = variant;
    this.x[index] = x;
    this.y[index] = y;
    this.prevX[index] = x;
    this.prevY[index] = y;
    this.vx[index] = 0;
    this.vy[index] = 0;
    this.hp[index] = hp;
    this.maxHp[index] = hp;
    this.radius[index] = radius;
    this.stateTimer[index] = 0;
    this.attackTimer[index] = 0;
    this.aux0[index] = 0;
    this.aux1[index] = 0;
    this.flags[index] = 0;
    this.score[index] = score;
    this.lux[index] = lux;
    this.lastAttackId[index] = 0;
    return index;
  }

  release(index: number): boolean {
    return this.indices.release(index);
  }

  reset(): void {
    this.indices.reset();
    this.overflowDrops = 0;
  }
}
